export const cards = {
    state: {
        favCards: {}
    },
    mutations: {
        TOGGLE_FAV_CARD (state, data) {
            if(state.favCards[data])
                state.favCards[data] = false
            else state.favCards[data] = true
        },
        SET_FAV_CARDS(state, data) {
            state.favCards = data
        }
    },
    actions: {
        toggleFavCard ({commit} , data) {
            commit('TOGGLE_FAV_CARD', data)
        },
        setFavCards({commit}, data) {
            commit('SET_FAV_CARDS', data)
        }
    }
}
